export default function(){
  return [
    {
      "ConditionalGroupName":"College 1",
      "AnonymousGroupName":"College 1",
      "GroupCode":"CON",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"CON (College of Nursing)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":87.2,
      "OverallScoreLabel":"Great Progress"
    },
    {
      "ConditionalGroupName":"College 2",
      "AnonymousGroupName":"College 2",
      "GroupCode":"CECH",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"CECH (College of Education, Criminal Justice, and Human Services)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":79.7,
      "OverallScoreLabel":"Attention Needed!"
    },
    {
      "ConditionalGroupName":"College 3",
      "AnonymousGroupName":"College 3",
      "GroupCode":"L",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"Law",
      "SemesterLabel":"Fall 2022",
      "OverallScore":78.5,
      "OverallScoreLabel":"Attention Needed!"
    },
      {"ConditionalGroupName":"College 4",
      "AnonymousGroupName":"College 4",
      "GroupCode":"P",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"Pharmacy",
      "SemesterLabel":"Fall 2022",
      "OverallScore":71.8,
      "OverallScoreLabel":"Attention Needed!"
    },
      {"ConditionalGroupName":"College 5",
      "AnonymousGroupName":"College 5",
      "GroupCode":"UCBA",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"UCBA (UC Blue Ash)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":71.6,
      "OverallScoreLabel":"Attention Needed!"
    },
    {
      "ConditionalGroupName":"College 6",
      "AnonymousGroupName":"College 6",
      "GroupCode":"ELCE",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"ELCE (Experience-Based Learning and Career Education)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":71.3,
      "OverallScoreLabel":"Attention Needed!"
    },
    {
      "ConditionalGroupName":"College 7",
      "AnonymousGroupName":"College 7",
      "GroupCode":"LCOB",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"LCB (Lindner College of Business)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":70.1,
      "OverallScoreLabel":"Attention Required!"
    },
    {
      "ConditionalGroupName":"College 8",
      "AnonymousGroupName":"College 8",
      "GroupCode":"AS",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"A\u0026S (Arts \u0026 Sciences)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":68.6,
      "OverallScoreLabel":"Attention Required!"
    },
    {
      "ConditionalGroupName":"CAHS (College of Allied Health Sciences)",
      "AnonymousGroupName":"College 9",
      "GroupCode":"CAHS",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"CAHS (College of Allied Health Sciences)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":67.5,
      "OverallScoreLabel":"Attention Required!"
    },
    {
      "ConditionalGroupName":"College 10",
      "AnonymousGroupName":"College 10",
      "GroupCode":"CEAS",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"CEAS (College of Engineering and Applied Science)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":67,
      "OverallScoreLabel":"Attention Required!"
    },
    {
      "ConditionalGroupName":"College 11",
      "AnonymousGroupName":"College 11",
      "GroupCode":"COM",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"COM (College of Medicine)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":65,
      "OverallScoreLabel":"Attention Required!"
    },
    {
      "ConditionalGroupName":"College 12",
      "AnonymousGroupName":"College 12",
      "GroupCode":"CCM",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"CCM (College Conservatory of Music)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":64.8,
      "OverallScoreLabel":"Attention Required!"
    },
    {
      "ConditionalGroupName":"College 13",
      "AnonymousGroupName":"College 13",
      "GroupCode":"UCC",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"UCC (UC Clermont Campus)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":61,
      "OverallScoreLabel":"Attention Needed!"
    },
    {
      "ConditionalGroupName":"College 14",
      "AnonymousGroupName":"College 14",
      "GroupCode":"DAAP",
      "GroupCodeFromUrl":"CAHS",
      "GroupName":"DAAP (Design, Architecture, Art, and Planning)",
      "SemesterLabel":"Fall 2022",
      "OverallScore":59.8,
      "OverallScoreLabel":"Attention Required!"
    }
  ]
}